import { SEARCH_ADS_APP_CPI_LIMIT } from '@/components/advertisement/search-ads/Bids/BidsContent/constants';
import {
  SEARCH_ADS_CAMPAIGN_HINTS,
  SEARCH_ADS_CAMPAIGN_HINTS_SET_KEYWORDS_HINT,
  SEARCH_ADS_CAMPAIGN_HINTS_SET_BUDGET_HINT,
  SEARCH_ADS_CAMPAIGN_HINTS_SET_CPI_LIMIT,
  RESET,
  SEARCH_ADS_RESET_HINTS,
} from '../../types';

export const state = () => ({
  hints: {
    addBudgetHint: false,
    addKeywordsHint: false,
    cpiLimit: SEARCH_ADS_APP_CPI_LIMIT,
  },
});

export const getters = {
  [SEARCH_ADS_CAMPAIGN_HINTS]({ hints }) {
    return hints;
  },
};

/* eslint-disable no-param-reassign */
export const mutations = {
  [SEARCH_ADS_CAMPAIGN_HINTS_SET_KEYWORDS_HINT](stateObj, value) {
    stateObj.hints.addKeywordsHint = value;
  },
  [SEARCH_ADS_CAMPAIGN_HINTS_SET_BUDGET_HINT](stateObj, value) {
    stateObj.hints.addBudgetHint = value;
  },
  [SEARCH_ADS_CAMPAIGN_HINTS_SET_CPI_LIMIT](stateObj, value) {
    stateObj.hints.cpiLimit = value;
  },
  [RESET](stateObj) {
    Object.assign(stateObj, state());
  },
  [SEARCH_ADS_RESET_HINTS](stateObj) {
    Object.assign(stateObj, state());
  },
};

export const actions = {
  [SEARCH_ADS_CAMPAIGN_HINTS_SET_KEYWORDS_HINT]({ commit }, value) {
    commit(SEARCH_ADS_CAMPAIGN_HINTS_SET_KEYWORDS_HINT, value);
  },
  [SEARCH_ADS_CAMPAIGN_HINTS_SET_BUDGET_HINT]({ commit }, value) {
    commit(SEARCH_ADS_CAMPAIGN_HINTS_SET_BUDGET_HINT, value);
  },
  [SEARCH_ADS_CAMPAIGN_HINTS_SET_CPI_LIMIT]({ commit }, value) {
    commit(SEARCH_ADS_CAMPAIGN_HINTS_SET_CPI_LIMIT, value);
  },
  [SEARCH_ADS_RESET_HINTS]({ commit }) {
    commit(SEARCH_ADS_RESET_HINTS);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
